var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "fieldset",
    [
      _c("legend", [_vm._v("Address / Location")]),
      _c("rbv-address-autocomplete", {
        attrs: {
          query: (_vm.viewValue && _vm.viewValue.fullAddress) || "",
          "show-form": _vm.formOpened,
        },
        on: { addManually: _vm.showForm, change: _vm.onLocationSelected },
      }),
      _vm.formOpened
        ? _c(
            "div",
            { staticClass: "layout-2-columns rbv-map-fields" },
            [
              _c("rbv-input-address", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: { name: "address" },
                on: { change: _vm.onAddressChanged },
                model: {
                  value: _vm.viewValue.address,
                  callback: function ($$v) {
                    _vm.$set(_vm.viewValue, "address", $$v)
                  },
                  expression: "viewValue.address",
                },
              }),
              _c(
                "div",
                { staticClass: "layout-column" },
                [
                  _c("rbv-input-coordinates", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'",
                      },
                    ],
                    staticClass: "layout-column flex-100 rbv-map",
                    attrs: { name: "coordinates", zoom: _vm.zoom },
                    on: { change: _vm.onCoordinatesChanged },
                    model: {
                      value: _vm.viewValue.coordinates,
                      callback: function ($$v) {
                        _vm.$set(_vm.viewValue, "coordinates", $$v)
                      },
                      expression: "viewValue.coordinates",
                    },
                  }),
                  _c("div", { class: _vm.$style.mapHint }, [
                    _vm._v(" Drag marker to adjust coordinates "),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }